<template>
  <div>
    <el-drawer
      ref="drawerRef"
      :visible.sync="drawerVisible"
      direction="ltr"
      :with-header="false"
      size="80%"
      @close="cancelDrawer"
    >
      <div style="display: flex;justify-content: space-between;align-items: center; margin: 40px 20px">
        <div>
          <span class="dn_title">{{ drawerTitleName }}</span>
          <span v-if="drawerCode" class="dn_code">{{ drawerCode }}</span>
        </div>
        <span class="el-icon-close dn_close" @click="cancelDrawer" />
      </div>
      <div style="padding-left: 20px; padding-right: 20px; box-sizing: border-box">
        <!--   基础信息   -->
        <el-divider content-position="left" class="divider_line_class">{{ $t('newOrder.BasicInformation') }}</el-divider>
        <el-form
          ref="formRef" :model="detailForm" class="selectClass"
        >
          <el-row type="flex" style="justify-content: space-around;align-items: center;flex-wrap: wrap">
            <el-col :span="10">
              <!-- 模块 -->
              <el-form-item
                :label="$t('collectionCenter.module')"
                :rules="[
                  {
                    required: true,
                    message: $t('collectionCenter.pleaseChoose'),
                    trigger: ['blur', 'change']
                  }
                ]"
                prop="moduleId"
              >
                <el-select
                  v-model="detailForm.moduleId"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  clearable filterable
                  style="width: 100%"
                  :disabled="opType === 3"
                  @change="changeModule"
                >
                  <el-option
                    v-for="(item, index) in moduleData"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <!-- 菜单 -->
              <el-form-item
                :label="$t('navbar.menu')"
                :rules="[
                  {
                    required: true,
                    message: $t('collectionCenter.pleaseChoose'),
                    trigger: ['blur', 'change']
                  }
                ]"
                prop="menuId"
              >
                <el-select
                  v-model="detailForm.menuId"
                  :placeholder="$t('navbar.pleaseSelectModule')"
                  clearable filterable
                  style="width: 100%"
                  :disabled="detailForm.moduleId === '' || opType === 3"
                >
                  <el-option
                    v-for="(item, index) in menuData"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <!-- 状态 -->
              <el-form-item
                :label="$t('trajectory.state')"
                :rules="[
                  {
                    required: true,
                    message: $t('collectionCenter.pleaseChoose'),
                    trigger: ['blur', 'change']
                  }
                ]"
                prop="status"
              >
                <el-select
                  v-model="detailForm.status"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  style="width: 100%"
                  :disabled="opType === 3"
                >
                  <el-option :label="$t('GlobalSetObj.enable')" :value="1" />
                  <el-option :label="$t('GlobalSetObj.stop')" :value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" />
          </el-row>
        </el-form>

        <!--   文档信息   -->
        <el-divider content-position="left" class="divider_line_class">{{ $t('navbar.documentInfo') }}</el-divider>
        <div style="margin: 0 auto">
          <el-button
            v-if="opType !== 3"
            size="mini" type="primary"
            style="margin-bottom: 10px"
            @click="addRowClick"
          >{{ $t('collectionCenter.add') }}</el-button>
          <el-form ref="tableRef" :model="tableForm">
            <el-table
              :data="tableForm.tableList"
              :header-cell-style="{background:'#f2f2f2',color:'black'}"
              border style="width: 100%;border-radius: 0 !important"
            >
              <!-- 语言 -->
              <el-table-column
                :label="$t('dictionary.language')" prop="language" align="center"
                min-width="120"
              >
                <template #default="{ row, $index }">
                  <span v-if="opType === 3">{{ row.language === 'zh-CN' ? '中文' : row.language === 'pt-BR' ? 'Português' : '' }}</span>
                  <el-form-item
                    v-else
                    :prop="`tableList.${$index}.language`"
                    :rules="rules.language"
                  >
                    <el-select
                      v-model="row.language"
                      :placeholder="$t('collectionCenter.pleaseChoose')"
                      clearable filterable
                      style="width: 100%"
                    >
                      <el-option label="中文" value="zh-CN" />
                      <el-option label="Português" value="pt-BR" />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- 文档名称 -->
              <el-table-column
                :label="$t('navbar.documentName')" prop="documentName" align="center"
                min-width="200"
              >
                <template #default="{ row, $index }">
                  <div v-if="opType === 3">
                    <el-tooltip placement="top">
                      <div slot="content" style="max-height: 200px;overflow: auto;max-width:500px">{{ row.documentName }}</div>
                      <div class="paramsStyle">{{ row.documentName }}</div>
                    </el-tooltip>
                  </div>
                  <el-form-item
                    v-else
                    :prop="`tableList.${$index}.documentName`"
                    :rules="rules.documentName"
                  >
                    <el-input
                      v-model="row.documentName" clearable
                      :placeholder="$t('collectionCenter.pleaseInput')"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- 文件名 -->
              <el-table-column
                :label="$t('basicData.fileName')" prop="fileName" align="center"
                min-width="100"
              >
                <template #default="{ row }">
                  <el-tooltip placement="top">
                    <div slot="content" style="max-height: 200px;overflow: auto;max-width:500px">{{ row.fileName }}</div>
                    <div class="paramsStyle">{{ row.fileName }}</div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <!-- 最新版本 -->
              <el-table-column
                :label="$t('basicData.LatestVersion')" prop="currentVersionName" align="center"
                min-width="100"
              >
                <template #default="{ row }">
                  <div v-if="!row.id">{{ row.currentVersionName }}</div>
                  <div v-else class="version_class" @click="totalCount(row, $t('navbar.historicalVersionQuery'), 2)">
                    {{ row.currentVersionName }}
                  </div>
                </template>
              </el-table-column>
              <!-- 状态 -->
              <el-table-column
                :label="$t('trajectory.state')" prop="status" align="center"
                min-width="100"
              >
                <template #default="{ row }">
                  <span v-if="row.status === 1" class="state_class green">
                    {{ $t('basicData.Effective') }}
                  </span>
                  <span v-if="row.status === 0" class="state_class red">
                    {{ $t('basicData.Ineffective') }}
                  </span>
                </template>
              </el-table-column>
              <!-- 更新人 -->
              <el-table-column
                v-if="opType !== 1"
                :label="$t('GlobalSetObj.Updater')" prop="updateUserName" align="center"
                min-width="100"
              >
                <template #default="{ row }">
                  <div>
                    {{ row.updateUserName }}
                  </div>
                </template>
              </el-table-column>
              <!-- 更新时间 -->
              <el-table-column
                v-if="opType !== 1"
                :label="$t('GlobalSetObj.UpdateTime')" prop="updateTime" align="center"
                min-width="100"
              >
                <template #default="{ row }">
                  <div>
                    {{ row.updateTime }}
                  </div>
                </template>
              </el-table-column>
              <!-- 操作 -->
              <el-table-column
                :label="$t('collectionCenter.operation')" align="center"
                :width="operationWidth"
              >
                <template #default="{ row, $index }">
                  <el-button
                    v-show="opType !== 3 && !row.id"
                    size="small" round class="btn_sum"
                    type="primary"
                    style="margin-bottom: 5px"
                    @click="openUpload($index)"
                  >{{ $t('collectionCenter.Upload') }}</el-button><!-- 上传 -->
                  <el-button
                    v-show="opType !== 3 && row.id"
                    size="small" round class="btn_sum"
                    type="primary"
                    style="margin-bottom: 5px"
                    @click="openUpload($index)"
                  >{{ $t('navbar.updateVersion') }}</el-button><!-- 更新版本 -->
                  <el-button
                    v-show="row.fileUrl"
                    size="small" round class="btn_sum"
                    type="primary"
                    style="margin-bottom: 5px"
                    @click="preViewFile(row)"
                  >{{ $t('operationCenter.Preview') }}</el-button><!-- 预览 -->
                  <el-button
                    v-show="row.fileUrl"
                    size="small" round class="btn_sum"
                    type="primary"
                    style="margin-bottom: 5px"
                    @click="downloadFile(row)"
                  >{{ $t('GlobalSetObj.Download') }}</el-button><!-- 下载 -->
                  <el-button
                    v-show="opType !== 3 && row.status === 1"
                    size="small" round type="danger"
                    class="btn_sum"
                    style="margin-bottom: 5px"
                    @click="row.status = 0"
                  >{{ $t('basicData.Ineffective') }}</el-button><!-- 失效 -->
                  <el-button
                    v-show="opType !== 3 && row.status === 0"
                    size="small" round
                    class="btn_sum"
                    type="primary"
                    style="margin-bottom: 5px"
                    @click="row.status = 1"
                  >{{ $t('basicData.Effective') }}</el-button><!-- 生效 -->
                  <el-button
                    v-show="opType !== 3"
                    size="small" round type="danger"
                    style="margin-bottom: 5px" class="btn_sum"
                    @click="delRow($index)"
                  >{{ $t('GlobalSetObj.Delete') }}</el-button><!-- 删除 -->
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>

        <div v-if="opType !== 3" style="padding: 20px; text-align: right">
          <el-button size="small" @click="cusSubmit(1)">{{ $t('GlobalSetObj.cancel') }}</el-button>
          <el-button size="small" type="primary" @click="cusSubmit(2)">
            {{ $t('customerManagements.Save') }}
          </el-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      :title="$t('collectionCenter.Upload')"
      :visible.sync="uploadShow"
      center
      width="500px"
      class="upld_box"
    >
      <el-upload
        class="upload-demo"
        drag action
        :file-list="fileList"
        :before-upload="beforeUpload"
        :http-request="Upload"
      >
        <i class="el-icon-upload" />
        <!--将文件拖到此处，或点击上传-->
        <div class="el-upload__text">{{ $t('basicData.DragTheFileHereOrClickUpload') }}</div>
        <!-- 支持上传pdf,doc,docx,xls,xlsx,pptx,png,jpg,jpeg格式，文件最大不能超过50MB-->
        <div slot="tip" class="el-upload__tip">{{ $t('navbar.fileUploadRestrictions') }}</div>
      </el-upload>
    </el-dialog>

    <dialogChild ref="dialogRef" />
  </div>
</template>

<script>
import { uploadOos } from '@/utils/ali_oos_util';
import dialogChild from './dialogChild.vue';
import { sopDetail, sopSave, sopUpdate } from '@/api/sop';
import { getUserName } from '@/utils/asyncTools';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { findLastLevelByFirstMenu } from '@/utils/menuHelper';

export default {
  name: 'Xxxxx',
  components: {
    dialogChild
  },
  props: {
    moduleList: {
      type: Array,
      default() {
        return [];
      }
    },
    menuList: {
      type: Array,
      default() {
        return [];
      }
    },
    permissionList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      drawerCode: '',
      drawerTitleName: '',
      drawerVisible: false,
      moduleData: [],
      menuData: [],
      detailForm: {
        moduleId: '',
        menuId: '',
        status: 1
      },
      tableForm: {
        tableList: [{
          status: null,
          language: '',
          documentName: '',
          fileName: '',
          fileUrl: '',
          latestVersion: '',
          editUser: '',
          editTime: ''
        }]
      },
      rules: {
        language: [{ required: true, message: this.$t('collectionCenter.notNull'), trigger: ['blur', 'change'] }],
        documentName: [{ required: true, message: this.$t('collectionCenter.notNull'), trigger: ['blur', 'change'] }]
      },
      opType: null,
      uploadShow: false,
      uploadIdx: null,
      fileList: [],
      operationWidth: 100 // 操作列宽度
    };
  },
  watch: {
    'tableForm.tableList': {
      handler() {
        this.calcWidth();
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => this.calcWidth());
  },
  methods: {
    changeModule(pId) {
      if (pId) {
        this.menuData = findLastLevelByFirstMenu(this.permissionList, pId);
      } else {
        this.detailForm.menuId = '';
        this.menuData = this.menuList;
      }
    },
    // 清空表单
    clearForm() {
      this.detailForm = {
        moduleId: '',
        menuId: '',
        status: 1
      };
      this.tableForm.tableList = [{
        status: null,
        language: '',
        documentName: '',
        fileName: '',
        fileUrl: '',
        latestVersion: '',
        editUser: '',
        editTime: ''
      }];
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
        if (this.$refs.tableRef) {
          this.$refs.tableRef.clearValidate();
        }
      });
    },
    // 操作列宽度
    calcWidth() {
      this.$nextTick(() => {
        // 获取所有可见按钮
        const btns = document.querySelectorAll('.btn_sum');
        let maxWidth = 0;
        const rows = {};
        btns.forEach(btn => {
          if (btn.style.display === 'none' || btn.offsetParent === null) return;
          const tr = btn.closest('tr');
          if (!tr) return;
          const key = tr.rowIndex || Array.from(tr.parentNode.children).indexOf(tr);
          if (!rows[key]) rows[key] = [];
          rows[key].push(btn.offsetWidth);
        });
        // 计算每行总宽度
        Object.values(rows).forEach(widths => {
          const total = widths.reduce((a, b) => a + b, 0) + (widths.length - 1) * 10;
          maxWidth = Math.max(maxWidth, total);
        });
        this.operationWidth = Math.max(160, maxWidth + 30);
      });
    },
    openDrawer(row, type, title) {
      // type：新增 1   编辑 2   查看 3
      this.opType = type;
      this.drawerTitleName = title;
      this.moduleData = this.moduleList;
      this.menuData = this.menuList;
      if (!row) {
        // 新增
        this.drawerVisible = true;
        this.clearForm();
      } else {
        // 编辑 / 查看
        if (type === 3 || type === 2) {
          sopDetail(row.id).then(res => {
            if (res.code === 200) {
              this.detailForm = {
                id: res.data.id,
                moduleId: res.data.moduleId,
                menuId: res.data.menuId,
                status: res.data.status
              };
              this.tableForm.tableList = res.data.documentList.map(item => {
                const updateUserName = getUserName(item.updateUser, getUserIdAndNameObj());
                item.updateUserName = updateUserName;
                item.cvnTotal = item.currentVersionName; // 用来更新正确的版本号；
                return item;
              });
              this.drawerVisible = true;
              this.drawerCode = type === 3 ? row.sopNo : '';
            }
          });
        }
      }
    },
    cancelDrawer() {
      this.drawerVisible = false;
      this.tableForm.tableList = [{
        status: null,
        language: '',
        documentName: '',
        fileName: '',
        fileUrl: '',
        latestVersion: '',
        editUser: '',
        editTime: ''
      }];
      this.drawerCode = '';
    },

    addRowClick() {
      const list = {
        status: null,
        language: '',
        documentName: '',
        fileName: '',
        fileUrl: '',
        latestVersion: '',
        editUser: '',
        editTime: ''
      };
      this.tableForm.tableList.push(list);
    },
    delRow(idx) {
      this.tableForm.tableList.splice(idx, 1);
    },
    totalCount(row, title, type) {
      // 传数据
      this.$nextTick(() => {
        this.$refs.dialogRef.getData(row, title, type);
      });
    },
    openUpload(idx) {
      this.uploadShow = true;
      this.uploadIdx = idx;
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      const whiteList = ['PDF', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'pptx', 'png', 'jpg', 'jpeg'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // 支持上传pdf,doc,docx,xls,xlsx,pptx,png,jpg,jpeg格式
        this.$message.error(this.$t('navbar.uploadOnly'));
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 50;
      if (!isLt10M) {
        // 上传文件大小不能超过 50MB
        this.$message.error(this.$t('collectionCenter.uploadNot50MB'));
        return false;
      }
    },
    Upload(option) {
      try {
        const file = option.file;
        uploadOos(file, 'sop').then(res => {
          if (res.code === 200) {
            const obj = {
              name: file.name,
              url: res.url
            };
            this.fileList = [obj]; // 看效果用，可删
            this.tableForm.tableList[this.uploadIdx].fileName = file.name;
            this.tableForm.tableList[this.uploadIdx].fileUrl = res.url;
            this.tableForm.tableList[this.uploadIdx].status = 1;
            if (this.opType === 1) {
              this.tableForm.tableList[this.uploadIdx].currentVersionName = 'V1';
            } else {
              const cvn = this.tableForm.tableList[this.uploadIdx].cvnTotal;
              const Vx = cvn ? cvn.split('V')[1] : '';
              this.tableForm.tableList[this.uploadIdx].currentVersionName = cvn ? 'V' + (Number(Vx) + 1) : 'V1';
            }
          } else {
            this.tableForm.tableList[this.uploadIdx].status = 0;
          }
        }).catch(err => {
          this.tableForm.tableList[this.uploadIdx].status = 0;
          this.$message.error(err.msg);
        }).finally(() => {
          this.uploadShow = false;
          this.fileList = [];
        });
      } catch (error) {
        console.error(error);
      }
    },
    // 预览
    preViewFile(row) {
      if (!row.fileUrl) {
        this.$message.warning(this.$t('navbar.fileNotExist'));
        return;
      }
      this.preFn(row);
    },
    preFn(row) {
      const ext = (row.fileName || '').substring(row.fileName.lastIndexOf('.') + 1).toLowerCase();
      const officeTypes = ['doc', 'docx', 'xls', 'xlsx', 'pptx'];
      const imgTypes = ['png', 'jpg', 'jpeg'];

      if (officeTypes.includes(ext)) {
        // Office文件使用在线预览
        const encodedUrl = encodeURIComponent(row.fileUrl);
        window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`, '_blank');
      } else if (imgTypes.includes(ext)) {
        // 图片直接打开
        const win = window.open('', '_blank');
        win.document.write(`
              <html>
                <head>
                  <title>图片预览</title>
                  <style>
                    body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background: #f5f5f5; }
                    img { max-width: 95%; max-height: 95%; object-fit: contain; }
                  </style>
                </head>
                <body>
                  <img src="${row.fileUrl}" />
                </body>
              </html>
            `);
        win.document.close();
      } else if (['pdf', 'PDF'].includes(ext)) {
        fetch(row.fileUrl)
          .then(response => response.blob())
          .then(blob => {
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
          })
          .catch(() => {
            // 降级方案：直接打开原链接
            window.open(row.fileUrl, '_blank');
          });
      } else {
        // 其余文件下载
        window.open(row.fileUrl, '_blank');
      }
    },
    // 下载
    downloadFile(row) {
      if (!row.fileUrl) {
        this.$message.warning(this.$t('navbar.fileNotExist'));
        return;
      }
      const link = document.createElement('a');
      link.href = row.fileUrl;
      link.download = row.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async cusSubmit(type) {
      if (type === 1) {
        this.cancelDrawer();
      } else {
        if (!this.tableForm.tableList || this.tableForm.tableList.length <= 0) {
          this.$message.warning(this.$t('collectionCenter.nullSubmit')); // 无数据提交
          return;
        }
        if (!this.validateFile()) return;
        try {
          const [valid1, valid2] = await Promise.all([
            this.$refs.formRef.validate(),
            this.$refs.tableRef.validate()
          ]);
          if (valid1 && valid2) {
            // 提交数据
            const documentList = this.tableForm.tableList.map(item => {
              if (this.opType === 2) {
                return {
                  id: item.id,
                  language: item.language,
                  documentName: item.documentName,
                  fileUrl: item.fileUrl,
                  fileName: item.fileName,
                  status: item.status
                };
              } else {
                return {
                  language: item.language,
                  documentName: item.documentName,
                  fileUrl: item.fileUrl,
                  fileName: item.fileName,
                  status: item.status
                };
              }
            });
            const submitForm = {
              moduleId: this.detailForm.moduleId,
              menuId: this.detailForm.menuId,
              status: this.detailForm.status,
              documentList
            };
            if (this.opType === 2) {
              submitForm.id = this.detailForm.id;
            }
            if (this.opType === 1) {
              sopSave(submitForm).then(res => {
                if (res.code === 200) {
                  this.$message.success(this.$t('userManage.TheOperationSucceeded'));
                  this.cancelDrawer();
                  this.$emit('search');
                }
              });
            }
            if (this.opType === 2) {
              sopUpdate(submitForm).then(res => {
                if (res.code === 200) {
                  this.$message.success(this.$t('userManage.TheOperationSucceeded'));
                  this.cancelDrawer();
                  this.$emit('search');
                }
              });
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    validateFile() {
      const fileErrors = [];
      this.tableForm.tableList.forEach((row, i) => {
        // 校验文件
        if (!row.fileName || !row.fileUrl) fileErrors.push(i + 1);
      });
      if (fileErrors.length) {
        // 第xx行需上传文件
        this.$message.warning(`${this.$t('navbar.rowPrefix')} ${fileErrors.join('、')} ${this.$t('navbar.rowSuffix')}`);
        return false;
      }
      return true;
    }

  }
};
</script>

<style lang="scss" scoped>
.dn_title {
  font-size: 19px;
  font-weight: bold;
  color: #19191a;
}
.dn_code {
  font-size: 14px;
  color: #336fff;
  background: #e5efff;
  border-radius: 20px;
  padding: 7px 10px;
  box-sizing: border-box;
  margin-left: 10px;
}
.dn_close {
  width: 20px;
  height: 20px;
  font-size: 20px;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.divider_line_class {
  background-color: #d0d0d0;
}
.divider_line_class ::v-deep .el-divider__text.is-left {
  font-size: 16px;
  color: #000;
  left: 0 !important;
  padding-left: 0 !important;
  padding-right: 15px !important;
}

.selectClass ::v-deep .el-form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.selectClass ::v-deep .el-form-item__label{
  padding: 0;
  font-size: 15px;
  color: #000;
  line-height: 16px;
  white-space: nowrap;
}
.selectClass ::v-deep .el-form-item__content{
  margin-left: 20px !important;
  flex: 1;
}
.selectClass ::v-deep .el-select .el-input.is-disabled .el-input__inner {
  border-color: #fff !important;
  box-shadow: 0 0 0 1px #e5e6eb !important;
  color: #1d2129 !important;
}

.version_class {
  color: #018be5;
  font-size: 15px;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

.state_class {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 20px;
  box-sizing: border-box;
}
.state_class.green {
  background: #e5efff;
  color: #336fff;
}
.state_class.red {
  background: #ffded6;
  color: #ff333a;
}

.upld_box ::v-deep .upload-demo {
  text-align: center;
}
.upld_box ::v-deep .el-upload, .upld_box ::v-deep .el-upload-dragger {
  width: 100%;
}

.paramsStyle {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
